import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_LV.json';
import audios from './LOVE_AUDIOS_LV.json';

export const LOVE_DATA_LV: ServiceData = {
  articles,
  audios,
};
